import Flake from './flake'
import gsap from 'gsap'

export default {
  points: [[-40.107,25],[-38.428,27.783],[-36.885,25],[-33.662,25],[-32.1,27.783],[-33.662,30.547],[-30.439,30.547],[-28.877,33.33],[-27.217,30.547],[-24.102,30.547],[-25.664,27.783],[-24.102,25],[-20.889,25],[-19.209,27.783],[-17.666,25],[-14.434,25],[-12.773,27.783],[-14.434,30.547],[-11.211,30.547],[-9.658,33.33],[-11.211,36.113],[-14.434,36.113],[-12.773,38.887],[-14.434,41.67],[-11.211,41.67],[-9.658,44.443],[-7.998,41.67],[-4.766,41.67],[-3.213,44.443],[-4.766,47.227],[-1.553,47.227],[0.01,50],[1.553,47.227],[4.785,47.227],[3.232,44.443],[4.785,41.67],[8.008,41.67],[9.678,44.443],[11.221,41.67],[14.443,41.67],[12.783,38.887],[14.443,36.113],[11.221,36.113],[9.678,33.33],[11.221,30.547],[14.443,30.547],[12.783,27.783],[14.443,25],[17.676,25],[19.229,27.783],[20.898,25],[24.111,25],[25.674,27.783],[24.111,30.547],[27.227,30.547],[28.896,33.33],[30.449,30.547],[33.662,30.547],[32.119,27.783],[33.662,25],[36.895,25],[38.457,27.783],[40.117,25],[43.33,25],[41.67,22.227],[43.33,19.443],[40.117,19.443],[38.457,16.67],[40.117,13.887],[43.33,13.887],[41.67,11.113],[43.33,8.33],[40.117,8.33],[38.457,5.547],[36.895,8.33],[33.662,8.33],[32.119,5.547],[33.662,2.783],[30.449,2.783],[28.896,0],[30.449,-2.773],[33.662,-2.773],[32.119,-5.547],[33.662,-8.34],[36.895,-8.34],[38.457,-5.547],[40.117,-8.34],[43.33,-8.34],[41.67,-11.113],[43.33,-13.887],[40.117,-13.887],[38.457,-16.67],[40.117,-19.434],[43.33,-19.434],[41.67,-22.217],[43.33,-25],[40.117,-25],[38.457,-27.773],[36.895,-25],[33.662,-25],[32.119,-27.773],[33.662,-30.557],[30.449,-30.557],[28.896,-33.34],[27.227,-30.557],[24.111,-30.557],[25.674,-27.773],[24.111,-25],[20.898,-25],[19.229,-27.773],[17.676,-25],[14.443,-25],[12.783,-27.773],[14.443,-30.557],[11.221,-30.557],[9.678,-33.34],[11.221,-36.113],[14.443,-36.113],[12.783,-38.887],[14.443,-41.67],[11.221,-41.67],[9.678,-44.434],[8.008,-41.67],[4.785,-41.67],[3.232,-44.434],[4.785,-47.217],[1.553,-47.217],[0.01,-50],[-1.553,-47.217],[-4.766,-47.217],[-3.213,-44.434],[-4.766,-41.67],[-7.998,-41.67],[-9.658,-44.434],[-11.211,-41.67],[-14.434,-41.67],[-12.773,-38.887],[-14.434,-36.113],[-11.211,-36.113],[-9.658,-33.34],[-11.211,-30.557],[-14.434,-30.557],[-12.773,-27.773],[-14.434,-25],[-17.666,-25],[-19.209,-27.773],[-20.889,-25],[-24.102,-25],[-25.664,-27.773],[-24.102,-30.557],[-27.217,-30.557],[-28.877,-33.34],[-30.439,-30.557],[-33.662,-30.557],[-32.1,-27.773],[-33.662,-25],[-36.885,-25],[-38.428,-27.773],[-40.107,-25],[-43.33,-25],[-41.67,-22.217],[-43.33,-19.434],[-40.107,-19.434],[-38.428,-16.67],[-40.107,-13.887],[-43.33,-13.887],[-41.67,-11.113],[-43.33,-8.34],[-40.107,-8.34],[-38.428,-5.547],[-36.885,-8.34],[-33.662,-8.34],[-32.1,-5.547],[-33.662,-2.773],[-30.439,-2.773],[-28.877,0],[-30.439,2.783],[-33.662,2.783],[-32.1,5.547],[-33.662,8.33],[-36.885,8.33],[-38.428,5.547],[-40.107,8.33],[-43.33,8.33],[-41.67,11.113],[-43.33,13.887],[-40.107,13.887],[-38.428,16.67],[-40.107,19.443],[-43.33,19.443],[-41.67,22.227],[-43.33,25]],
  position: {
    x: 0,
    y: 0
  },
  dist: 0,
  target: {
    x: 0,
    y: 0
  },
  update: {
    interval: 1000 / 30
  },
  interval: 0,
  animation: null,
  active: false,
  particles: {
    last: 0,
    list: {},
    active: []
  },
  scale: 1,
  opacity: 1,
  canMove: true,
  init (options) {
    this.options = options

    this.scale = options.scale

    window.addEventListener('touchstart', () => {
      this.canMove = true
    })
    window.addEventListener('touchend', () => {
      this.canMove = false
    })
    window.addEventListener('mousemove', e => {
      if (this.canMove) {
        this.mouseMove(e)
      }
    })

    for (let i = 0; i < this.options.particles.nb; i++) {
      this.particles.list[i] = new Flake(this.options.particles)
    }

    return this
  },
  mouseMove (e) {
    if (!this.active) {
      this.active = true
      this.position = {
        x: e.clientX,
        y: e.clientY
      }
    }
    this.target = {
      x: e.clientX,
      y: e.clientY
    }
  },
  hide () {
    this.transition = gsap.to(this, {
      duration: 0.5,
      ease: 'sine.out',
      scale: this.options.scale * 1.5,
      opacity: 0
    })
  },
  show () {
    this.transition = gsap.to(this, {
      duration: 0.5,
      ease: 'sine.out',
      scale: this.options.scale,
      opacity: 1
    })
  },
  updatePosition (fpsModifier) {
    this.position.x += (this.target.x - this.position.x) * this.options.speed.min * fpsModifier
    this.position.y += (this.target.y - this.position.y) * this.options.speed.min * fpsModifier

    this.dist = Math.sqrt(Math.abs(this.target.x - this.position.x) ** 2 + Math.abs(this.target.y - this.position.y))
  },
  activationLoop (fpsModifier) {
    this.interval += 0.0166 * fpsModifier
    if (this.dist > 1 && this.interval >= this.options.particles.life / this.options.particles.nb) {
      this.interval = 0
      const p = this.particles.list[this.particles.last]

      this.particles.active.push(p)
      this.particles.last++
      if (this.particles.last === Object.keys(this.particles.list).length) {this.particles.last = 0}
      p.activate({
        position: this.position
      }, () => {
        this.particles.active.splice(this.particles.active.indexOf(p) ,1)
      })
    }
  },
  draw (ctx) {
    if (this.opacity > 0) {
      this.particles.active.forEach(f => {
        const dir = f.setDirection(this.position)

        const m = f.life / f.lifespan
        const scale = this.options.particles.size.min + (this.options.particles.size.max - this.options.particles.size.min) * m

        let pos
        if (this.options.particles.addMovement) {
          f.position.x += dir.x
          f.position.y += dir.y
          pos = f.position
        } else {
          pos = {
            x: f.position.x + dir.x,
            y: f.position.y + dir.y,
          }
        }

        ctx.beginPath()
        ctx.fillStyle = 'rgba(' + f.color + ',' + (m * this.opacity) + ')'
        this.points.forEach((p, i) => {
          if (i === 0) {
            ctx.moveTo(p[0] * scale + pos.x, p[1] * scale + pos.y)
          } else {
            ctx.lineTo(p[0] * scale + pos.x, p[1] * scale + pos.y)
          }
        })
        ctx.fill()
        ctx.closePath()
      })

      ctx.beginPath()
      ctx.fillStyle = 'rgba(' + this.options.color + ',' + this.opacity + ')'
      this.points.forEach((p, i) => {
        if (i === 0) {
          ctx.moveTo(p[0] * this.scale + this.position.x, p[1] * this.scale + this.position.y)
        } else {
          ctx.lineTo(p[0] * this.scale + this.position.x, p[1] * this.scale + this.position.y)
        }
      })
      ctx.fill()
      ctx.closePath()
    }
  }
}